import SimpleBar from 'simplebar';
import catalogModule from '../catalogModule';

function catalogContentController($log, $scope) {
  'ngInject';

  $scope.initializeScrollbar = function () {
    const scrollbarElement = document.getElementById('search-options-scrollbar-container');
    if (scrollbarElement !== null && $scope.simpleBar === undefined) {
      const simpleBar = new SimpleBar(scrollbarElement);
      $scope.simpleBar = simpleBar;
    }
  };

  $scope.isInitializedPage = () => {
    const { initialized, isPhone, isApp } = $scope.library;
    if ($scope.stickyUiEnabled) {
      // $scope.initializeScrollbar();
    }
    return initialized && !(isPhone && isApp);
  };
}

catalogModule.controller('catalogContentController', catalogContentController);

export default catalogContentController;
